import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { EditorMergeImage } from '../../domain';
import {
  CollapsibleImageListPanelComponent,
  ImageListItem,
  ImageListPanelLabels,
} from '../side-panel/collapsible-image-list-panel';

@Component({
  selector: 'lib-merge-image-panel',
  imports: [CollapsibleImageListPanelComponent],
  templateUrl: './merge-image-panel.component.html',
  styleUrl: './merge-image-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MergeImagePanelComponent {
  readonly images = input<EditorMergeImage[]>([]);
  readonly processing = input(false);
  /** The custom layout exposes per-image X/Y inputs. */
  readonly showPositions = input(false);

  readonly filesSelected = output<File[]>();
  readonly imageReordered = output<MergeImageReorderEvent>();
  readonly imagePositionChanged = output<MergeImagePositionEvent>();
  readonly imageDeleted = output<string>();
  readonly imageDuplicated = output<string>();

  protected readonly labels: ImageListPanelLabels = {
    titleKey: 'EDITOR.MERGE.IMAGES_TITLE',
    expandKey: 'EDITOR.MERGE.ACTIONS.EXPAND',
    collapseKey: 'EDITOR.MERGE.ACTIONS.COLLAPSE',
    addKey: 'EDITOR.MERGE.ACTIONS.ADD_IMAGES',
    emptyKey: 'EDITOR.MERGE.EMPTY_IMAGES',
    duplicateKey: 'EDITOR.MERGE.ACTIONS.DUPLICATE_IMAGE',
    deleteKey: 'EDITOR.MERGE.ACTIONS.DELETE_IMAGE',
  };

  protected readonly canAlwaysDuplicate = (_index: number): boolean => true;
  protected readonly canDeleteImage = (_index: number): boolean => this.images().length > 1;

  protected onPositionChanged(item: ImageListItem, axis: 'x' | 'y', event: Event): void {
    event.stopPropagation();
    const inputElement = event.target as HTMLInputElement;
    const value = Number(inputElement.value);

    this.imagePositionChanged.emit({
      id: item.id,
      x: axis === 'x' ? value : (item.x ?? 0),
      y: axis === 'y' ? value : (item.y ?? 0),
    });
  }
}

export interface MergeImageReorderEvent {
  id: string;
  position: number;
}

export interface MergeImagePositionEvent {
  id: string;
  x: number;
  y: number;
}
